import React from "react";
import { Spinner } from "react-bootstrap";

export default function LoadingIndicator(): React.JSX.Element {
  /**
   * Simple loading indicator that can be used throughout the project.
   */
  return (
    <div className="flex-grow-1 h-100 w-100 d-flex justify-content-center align-items-center">
      <Spinner animation="border" variant="dark" />
    </div>
  );
}
